/**
 * Speak Italian text via the browser's Web Speech API. No-op where unsupported.
 * Shared by the vocabulary flashcards, the dashboard side panel, and the
 * speaking exercises.
 */
export function speakItalian(text: string, onEnd?: () => void) {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "it-IT";
  const italianVoice = window.speechSynthesis.getVoices().find((v) => v.lang.startsWith("it"));
  if (italianVoice) utterance.voice = italianVoice;
  if (onEnd) utterance.onend = onEnd;
  window.speechSynthesis.speak(utterance);
}

export function stopItalian() {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return;
  window.speechSynthesis.cancel();
}
